module.exports = __webpack_public_path__ + "img/STK20211203V2.bd405feb.jpg";